import Select from 'react-select'
import {KTIcon} from '../../../_metronic/helpers'
import {TUserFranchiseLink} from '../../../coreGlobal/models/user'
import {UsersForm} from '../core/UsersFormProvider'

// Vínculo do usuário com as franquias: o usuário pode estar vinculado a uma franquia sem estar ativo nela
export const UserFranchisesField = ({formik}) => {
  const {franchises} = UsersForm()
  const links: TUserFranchiseLink[] = formik.values.franchises ?? []

  const linkedIds = links.map((link) => Number(link.id))
  const availableOptions = franchises.filter((option) => !linkedIds.includes(Number(option.value)))

  const franchiseName = (link: TUserFranchiseLink) =>
    franchises.find((option) => Number(option.value) === Number(link.id))?.label ?? link.name

  const setLinks = (value: TUserFranchiseLink[]) => {
    formik.setFieldValue('franchises', value)
    formik.setFieldTouched('franchises', true, false)
  }

  const addLink = (option) => {
    if (!option) return
    setLinks([...links, {id: Number(option.value), name: String(option.label), active: true}])
  }

  const toggleActive = (id: number) =>
    setLinks(links.map((link) => (link.id === id ? {...link, active: !link.active} : link)))

  const removeLink = (id: number) => setLinks(links.filter((link) => link.id !== id))

  return (
    <>
      <Select
        className='react-select-styled react-select-solid mb-4'
        classNamePrefix='react-select'
        options={availableOptions}
        value={null}
        onChange={addLink}
        placeholder='Adicionar unidade'
        noOptionsMessage={() => 'Nenhuma unidade disponível'}
      />

      {links.length > 0 && (
        <div className='table-responsive'>
          <table className='table align-middle table-row-dashed fs-6 gy-3 mb-0'>
            <thead>
              <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                <th>Unidade</th>
                <th className='w-125px'>Ativo</th>
                <th className='w-50px'></th>
              </tr>
            </thead>
            <tbody>
              {links.map((link) => (
                <tr key={link.id}>
                  <td className='text-gray-800'>{franchiseName(link)}</td>
                  <td>
                    <div className='form-check form-switch form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={link.active}
                        onChange={() => toggleActive(link.id)}
                      />
                    </div>
                  </td>
                  <td className='text-end'>
                    <button
                      type='button'
                      className='btn btn-icon btn-sm btn-light-danger'
                      title='Remover vínculo'
                      onClick={() => removeLink(link.id)}
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
